import { type ReactNode } from 'react';
import { Link as RouterLink, matchPath, useLocation } from 'react-router-dom';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import Tab from '@liquidweb-dev/undercurrent/Tab';
import Tabs from '@liquidweb-dev/undercurrent/Tabs';
import { paths, useLeftHandLayout } from 'components/LeftHandLayout';
import TabBar from 'components/TabBar';

const TABS = [
	{ path: paths.endpointProtection, label: 'Endpoint Protection' },
	{ path: paths.serverProtection, label: 'Server Protection' },
];

export interface SecurityLayoutProps {
	children: ReactNode;
}

/**
 * The Security page's tab bar, one tab per security product, above the
 * selected product's own page. Each tab is a route, so the selected tab
 * comes from the pathname, matched the way the router matches it, so a
 * trailing slash or different letter case still selects the tab.
 */
const SecurityLayout = ({ children }: SecurityLayoutProps) => {
	const { topInnerX } = useLeftHandLayout();
	const { pathname } = useLocation();

	const selectedTab = TABS.find(({ path }) =>
		matchPath(pathname, { path, exact: true }),
	)?.path;

	return (
		<Stack sx={{ flexGrow: 1 }}>
			{/* Tabs only have a gap below them, and this bar sits right under the top bar. */}
			<TabBar sx={{ paddingX: `${topInnerX}px`, paddingTop: 100 }}>
				<Tabs value={selectedTab ?? false} variant="scrollable">
					{TABS.map(({ path, label }) => (
						<Tab
							key={path}
							component={RouterLink}
							value={path}
							to={path}
							label={label}
						/>
					))}
				</Tabs>
			</TabBar>
			{children}
		</Stack>
	);
};

export default SecurityLayout;
